'use strict';

var BidPriceChart = function BidPriceChart(AbstractChart, chartCurves, chartXAxis, chartYAxis, chartConstants, chartVerticalLine, chartHoverOver) {
  var chartParams = require('./Params');
  var chartScales = require('./Scales');
  var Chart = function Chart(container, formatters) {
    AbstractChart.call(this, container);
    this.tooltipClassName = 'bid-price-chart-tip';
    var curves = chartCurves('seatAvailIndex', 'bidPrice', 'bidPrices');
    var verticalLine = chartVerticalLine('seatsAvailableModel');
    var xAxis = chartXAxis(formatters.xAxisTickFormatter).label('Seats');
    var yAxisLeft = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.LEFT).withoutHorizontalLines().label('Bid Price');
    var hoverOver = chartHoverOver('bidPrices', 'seatAvailIndex', 'bidPrice', formatters.tooltipFormatter, undefined, this.tooltipClassName, 'cursor');
    this.render = function (data) {
      this.initChart(data, undefined, chartParams);
      this.scales = chartScales(this.params, this.data);
      this.callForDataGroup([yAxisLeft, curves, verticalLine.withData(data), xAxis, hoverOver], this.scales);
    };
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
BidPriceChart.$inject = ['AbstractChart', 'ChartElementsCurves', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsConstants', 'ChartElementsVerticalLine', 'ChartElementsHoverOver'];
module.exports = BidPriceChart;